import { useFormContext } from "react-hook-form";
import type { FeedbackFormValues, IssueTypeId } from "./useFeedbackForm";

export function useFeedbackFormMediator() {
  const { setValue } = useFormContext<FeedbackFormValues>();

  const onIssueTypeChange = (value: string) => {
    setValue("issueType", value as IssueTypeId);
    setValue("severity", undefined);
    setValue("description", "");
  };

  return { onIssueTypeChange };
}
